import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Global catch-all — surfaces errors that bypass React's boundary
window.onerror = (msg, src, line, col, err) => {
  console.error("[window.onerror]", msg, "| source:", src, "| line:", line, "| col:", col, "| error:", err);
};
window.onunhandledrejection = (evt) => {
  console.error("[unhandledrejection]", evt.reason);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
